import { Mail } from "lucide-react";

/**
 * Shown on /admin/orders and /admin/wholesale-inquiries to warn that email
 * distribution is not set up yet (requires domain + Resend). Instructs to
 * contact the developer once they have a domain.
 */
export function AdminEmailNotConfiguredNotice() {
  return (
    <div
      className="mb-6 flex items-start gap-3 rounded-lg border border-[#C7A76C] bg-[#C7A76C08 px-4 py-3"
      style={{ fontFamily: "'Jost', sans-serif", fontSize: "13px" }}
      role="status"
    >
      <Mail className="mt-0.5 shrink-0 text-[#C7A76C]" size={18} />
      <div className="text-[#2D2A26]">
        <p className="font-medium text-[#6F675F] mb-0.5">Email distribution not configured</p>
        <p className="font-normal text-[#6F675F]">
          Order and wholesale notification emails require a configured domain. Contact the developer to set this up once you have your domain name.
        </p>
      </div>
    </div>
  );
}
